import { render } from "./PCard.vue?vue&type=template&id=1ddf5930&scoped=true"
import script from "./PCard.vue?vue&type=script&lang=js"
export * from "./PCard.vue?vue&type=script&lang=js"

import "./PCard.vue?vue&type=style&index=0&id=1ddf5930&lang=less&scoped=true"

import exportComponent from "/builds/sqMDsSTzB/0/dsp/plazkart-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddf5930"]])

export default __exports__